import { useContext, useState } from 'react'
import { XCircle, CheckCircle } from '@styled-icons/boxicons-solid'

import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import FileField from '../../../../common/FileField'
import InputText from '../../../../common/InputText'
import TextArea from '../../../../common/TextArea'
import { postRequest } from '../../../../../services/base'
import { useParams } from 'react-router-dom'
import Button from '../../../../common/Button'
import { PluginContext, SHOW_DEF_BULK_UPLOAD } from '../context/context'
import { ProgresSpinner } from '../../../../common/ProgresSpinner'
import { NavContext } from '../../../../../context/global_context'

const DEFAULT_PAYLOAD = {
  def_file: '',
  supp_file: '',
  abbreviation: '',
  file_id: '',
  description: '',
}

const DefBulkUpload = ({ onClose }) => {
  const [navState, navDispatch] = useContext(NavContext)

  const [state, dispatch] = useContext(PluginContext)

  const [data, setData] = useState([{ ...DEFAULT_PAYLOAD, id: Math.random() }])
  const [error, setError] = useState([])
  const { vehicle } = useParams()

  const uploadProgressFunction = (progressEvent) => {
    const totalLength = progressEvent.lengthComputable
      ? progressEvent.total
      : progressEvent.target.getResponseHeader('content-length') ||
        progressEvent.target.getResponseHeader('x-decompressed-content-length')

    const percentageCompleted = Math.round(
      (progressEvent.loaded * 100) / totalLength
    )
    if (percentageCompleted === 100) {
      navDispatch({
        type: 'loader',
        data: {},
        notification: {},
      })
      setData([])
    }
  }

  const saveDefBulkUpload = async (e) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `DEF File upload is in progress, Don't Refresh Or close Window`,
        showLoader: true,
      },
      notification: {},
    })
    const form = e.target
    const formData = new FormData(form)
    let res = await postRequest(
      `/api/plugin/def/bulk_upload/${vehicle}/`,
      formData,
      false,
      {
        onUploadProgress: (progressEvent) => {
          uploadProgressFunction(progressEvent)
        },
      }
    )
    setError(res?.error)
    Object.keys(res?.error)?.length > 0
      ? reviewErrorFiles(res?.error)
      : setData([])
  }

  const setSelectedObjValue = (field_name, value, index) => {
    let selectedArray = [...data]
    selectedArray[index][field_name] = value
    setData(selectedArray)
  }

  const removeSelected = (index) => {
    let temp = [...data]
    temp.splice(index, 1)
    setData(temp)
  }

  const reviewErrorFiles = (errors) => {
    let tempData = []
    let errorKeys = Object.keys(errors)
    errorKeys.forEach((key, index) => {
      if (key < data.length) {
        let tempObj = { ...data[key] }
        tempObj['error'] = errors[key]
        tempData.push(tempObj)
      }
    })
    setData(tempData)
  }

  return (
    <Modal
      onClose={() => {
        dispatch({ type: SHOW_DEF_BULK_UPLOAD, data: false })
        onClose()
      }}
      show={true}
      size={'w-3/4'}
    >
      <ModalHeader className={'text-white'}>DEF File's</ModalHeader>
      <ModalBody>
        {data?.length < 1 && Object.keys(error)?.length < 1 ? (
          <div className="flex items-center justify-center  text-green-500">
            <div className="text-center">
              <CheckCircle
                className={'text-green-500 mr-3 cursor-pointer'}
                size="2rem"
              />
              <div>
                <div className="text-2xl">DEF Files Successfully Uploaded</div>
                <div>
                  **We are processing files, so check status. Will Let you know
                  once Process completed
                </div>
              </div>
            </div>
          </div>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault()
              saveDefBulkUpload(e)
            }}
          >
            <input type="hidden" value={data.length} name={`total_files`} />
            {data.map((value, index) => {
              return (
                <div key={`${index}-plugin-view-${value.id}}`}>
                  <input
                    type="hidden"
                    name="harness-id"
                    value={value.file_id}
                  />
                  <div className="flex">
                    <div className="w-2/12">
                      <FileField
                        key={`${index}-def_file`}
                        label="Def File"
                        name={`${index}-def_file`}
                        isRequired={true}
                        onChange={(e) => {
                          setSelectedObjValue('def_file', e.target.value, index)
                        }}
                        value={value.def_file}
                      />
                    </div>
                    <div className="w-2/12">
                      <FileField
                        label="Supp File"
                        name={`${index}-supp_file`}
                        key={`${index}-supp_file`}
                        isRequired={false}
                        onChange={(e) => {
                          setSelectedObjValue(
                            'supp_file',
                            e.target.value,
                            index
                          )
                        }}
                        value={value.supp_file}
                      />
                    </div>
                    <div className="w-2/12">
                      <InputText
                        type="text"
                        name={`${index}-file_id`}
                        key={`${index}-file_id`}
                        label="File Id"
                        isRequired={true}
                        onChange={(e) => {
                          setSelectedObjValue('file_id', e, index)
                        }}
                        value={value.file_id}
                      />
                    </div>
                    <div className="w-2/12 ">
                      <InputText
                        name={`${index}-abbreviation`}
                        key={`${index}-abbreviation`}
                        label="Abbreviation"
                        type="text"
                        isRequired={false}
                        onChange={(e) => {
                          setSelectedObjValue('abbreviation', e, index)
                        }}
                        value={value.abbreviation}
                      />
                    </div>
                    <div className="w-4/12 text-white flex items-center">
                      <TextArea
                        name={`${index}-description`}
                        key={`${index}-description`}
                        label="Description"
                        isRequired={false}
                        onChange={(e) => {
                          setSelectedObjValue('description', e, index)
                        }}
                        value={value.description}
                      />
                      {index != 0 && data.length - 1 == index && (
                        <XCircle
                          className={'text-red-500 mr-3 cursor-pointer'}
                          size="2rem"
                          onClick={() => {
                            removeSelected(index)
                          }}
                        />
                      )}
                    </div>
                  </div>
                  {value?.error && (
                    <div className="flex justify-end text-red-700">
                      {value.error}
                    </div>
                  )}
                </div>
              )
            })}
            <div className="flex justify-end text-blue-100">
              <span
                onClick={() => {
                  let tempData = [...data]
                  tempData.push({ ...DEFAULT_PAYLOAD, id: Math.random() })
                  setData(tempData)
                }}
                className="underline cursor-pointer"
              >
                {' '}
                Add More Files
              </span>
            </div>

            <div className="flex justify-end">
              <div className="w-1/4">
                <Button
                  type="submit"
                  className={`cursor-pointer btn my-4 w-full justify-end`}
                  onClick={(e) => {}}
                  value={'text'}
                  text={'Save Bulk Def Files'}
                />
              </div>
            </div>
          </form>
        )}
      </ModalBody>
    </Modal>
  )
}

export default DefBulkUpload
